// action types for artists
export const SET_ARTISTS_DATA = "SET_ARTISTS_DATA";
export const ADD_ARTIST = "ADD_ARTIST";
export const UPDATE_ARTIST = "UPDATE_ARTIST";
export const DELETE_ARTIST = "DELETE_ARTIST";
